"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatures = exports.tokens = void 0;
const erc20_json_1 = __importDefault(require("./42161/erc20.json"));
const erc20_json_2 = __importDefault(require("./421613/erc20.json"));
const erc20_json_3 = __importDefault(require("./592/erc20.json"));
const erc20_json_4 = __importDefault(require("./84531/erc20.json"));
const erc20_json_5 = __importDefault(require("./199/erc20.json"));
const erc20_json_6 = __importDefault(require("./56/erc20.json"));
const erc20_json_7 = __importDefault(require("./25/erc20.json"));
const erc20_json_8 = __importDefault(require("./246/erc20.json"));
const erc20_json_9 = __importDefault(require("./1/erc20.json"));
const erc20_json_10 = __importDefault(require("./5/erc20.json"));
const erc20_json_11 = __importDefault(require("./4/erc20.json"));
const erc20_json_12 = __importDefault(require("./3/erc20.json"));
const erc20_json_13 = __importDefault(require("./11155111/erc20.json"));
const erc20_json_14 = __importDefault(require("./250/erc20.json"));
const erc20_json_15 = __importDefault(require("./14/erc20.json"));
const erc20_json_16 = __importDefault(require("./8217/erc20.json"));
const erc20_json_17 = __importDefault(require("./1088/erc20.json"));
const erc20_json_18 = __importDefault(require("./1284/erc20.json"));
const erc20_json_19 = __importDefault(require("./10/erc20.json"));
const erc20_json_20 = __importDefault(require("./420/erc20.json"));
const erc20_json_21 = __importDefault(require("./137/erc20.json"));
const erc20_json_22 = __importDefault(require("./1101/erc20.json"));
const erc20_json_23 = __importDefault(require("./1442/erc20.json"));
const erc20_json_24 = __importDefault(require("./30/erc20.json"));
const erc20_json_25 = __importDefault(require("./19/erc20.json"));
const erc20_json_26 = __importDefault(require("./57/erc20.json"));
const erc20_json_27 = __importDefault(require("./40/erc20.json"));
const erc20_json_28 = __importDefault(require("./106/erc20.json"));
const erc20_signatures_json_1 = __importDefault(require("./42161/erc20-signatures.json"));
const erc20_signatures_json_2 = __importDefault(require("./421613/erc20-signatures.json"));
const erc20_signatures_json_3 = __importDefault(require("./592/erc20-signatures.json"));
const erc20_signatures_json_4 = __importDefault(require("./84531/erc20-signatures.json"));
const erc20_signatures_json_5 = __importDefault(require("./199/erc20-signatures.json"));
const erc20_signatures_json_6 = __importDefault(require("./56/erc20-signatures.json"));
const erc20_signatures_json_7 = __importDefault(require("./25/erc20-signatures.json"));
const erc20_signatures_json_8 = __importDefault(require("./246/erc20-signatures.json"));
const erc20_signatures_json_9 = __importDefault(require("./1/erc20-signatures.json"));
const erc20_signatures_json_10 = __importDefault(require("./5/erc20-signatures.json"));
const erc20_signatures_json_11 = __importDefault(require("./4/erc20-signatures.json"));
const erc20_signatures_json_12 = __importDefault(require("./3/erc20-signatures.json"));
const erc20_signatures_json_13 = __importDefault(require("./11155111/erc20-signatures.json"));
const erc20_signatures_json_14 = __importDefault(require("./250/erc20-signatures.json"));
const erc20_signatures_json_15 = __importDefault(require("./14/erc20-signatures.json"));
const erc20_signatures_json_16 = __importDefault(require("./8217/erc20-signatures.json"));
const erc20_signatures_json_17 = __importDefault(require("./1088/erc20-signatures.json"));
const erc20_signatures_json_18 = __importDefault(require("./1284/erc20-signatures.json"));
const erc20_signatures_json_19 = __importDefault(require("./10/erc20-signatures.json"));
const erc20_signatures_json_20 = __importDefault(require("./420/erc20-signatures.json"));
const erc20_signatures_json_21 = __importDefault(require("./137/erc20-signatures.json"));
const erc20_signatures_json_22 = __importDefault(require("./1101/erc20-signatures.json"));
const erc20_signatures_json_23 = __importDefault(require("./1442/erc20-signatures.json"));
const erc20_signatures_json_24 = __importDefault(require("./30/erc20-signatures.json"));
const erc20_signatures_json_25 = __importDefault(require("./19/erc20-signatures.json"));
const erc20_signatures_json_26 = __importDefault(require("./57/erc20-signatures.json"));
const erc20_signatures_json_27 = __importDefault(require("./40/erc20-signatures.json"));
const erc20_signatures_json_28 = __importDefault(require("./106/erc20-signatures.json"));
exports.tokens = {
    42161: erc20_json_1.default,
    421613: erc20_json_2.default,
    592: erc20_json_3.default,
    84531: erc20_json_4.default,
    199: erc20_json_5.default,
    56: erc20_json_6.default,
    25: erc20_json_7.default,
    246: erc20_json_8.default,
    1: erc20_json_9.default,
    5: erc20_json_10.default,
    4: erc20_json_11.default,
    3: erc20_json_12.default,
    11155111: erc20_json_13.default,
    250: erc20_json_14.default,
    14: erc20_json_15.default,
    8217: erc20_json_16.default,
    1088: erc20_json_17.default,
    1284: erc20_json_18.default,
    10: erc20_json_19.default,
    420: erc20_json_20.default,
    137: erc20_json_21.default,
    1101: erc20_json_22.default,
    1442: erc20_json_23.default,
    30: erc20_json_24.default,
    19: erc20_json_25.default,
    57: erc20_json_26.default,
    40: erc20_json_27.default,
    106: erc20_json_28.default,
};
exports.signatures = {
    42161: erc20_signatures_json_1.default,
    421613: erc20_signatures_json_2.default,
    592: erc20_signatures_json_3.default,
    84531: erc20_signatures_json_4.default,
    199: erc20_signatures_json_5.default,
    56: erc20_signatures_json_6.default,
    25: erc20_signatures_json_7.default,
    246: erc20_signatures_json_8.default,
    1: erc20_signatures_json_9.default,
    5: erc20_signatures_json_10.default,
    4: erc20_signatures_json_11.default,
    3: erc20_signatures_json_12.default,
    11155111: erc20_signatures_json_13.default,
    250: erc20_signatures_json_14.default,
    14: erc20_signatures_json_15.default,
    8217: erc20_signatures_json_16.default,
    1088: erc20_signatures_json_17.default,
    1284: erc20_signatures_json_18.default,
    10: erc20_signatures_json_19.default,
    420: erc20_signatures_json_20.default,
    137: erc20_signatures_json_21.default,
    1101: erc20_signatures_json_22.default,
    1442: erc20_signatures_json_23.default,
    30: erc20_signatures_json_24.default,
    19: erc20_signatures_json_25.default,
    57: erc20_signatures_json_26.default,
    40: erc20_signatures_json_27.default,
    106: erc20_signatures_json_28.default,
};
exports.default = {
    tokens: exports.tokens,
    signatures: exports.signatures,
};
//# sourceMappingURL=index.js.map